import { useQuery } from '@tanstack/react-query';
import { getNonManagedPortfolioStats, getStats } from '../service';

function useGetStats(propertyManagerId?: number | string | null) {
    const query = useQuery({
        queryKey: ['stats', propertyManagerId],
        queryFn: () => getStats(propertyManagerId),
    });

    return query;
}

function useGetNonManagedStats() {
    const query = useQuery({
        queryKey: ['stats', 'non-managed'],
        queryFn: () => getNonManagedPortfolioStats(),
    });

    return query;
}

export { useGetStats, useGetNonManagedStats };
